import {
  debounce,
  setupLogger,
} from '../utils.js'

const { logger, loggerError } = setupLogger('CaseManager', 'orchid')


const closedIcon = '<svg class="icon" viewBox="0 0 256 256" aria-hidden="true" width="24" height="24"><rect width="256" height="256" fill="none"/><path d="M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" fill="currentColor"/></svg>'
const openIcon = '<svg class="icon" viewBox="0 0 256 256" aria-hidden="true" width="24" height="24"><rect width="256" height="256" fill="none"/><path d="M245,110.64A16,16,0,0,0,232,104H216V88a16,16,0,0,0-16-16H130.67L102.94,51.2a16.14,16.14,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V208h0a8,8,0,0,0,8,8H211.1a8,8,0,0,0,7.59-5.47l28.49-85.47A16.05,16.05,0,0,0,245,110.64ZM93.34,64,123.2,86.4A8,8,0,0,0,128,88h72v16H69.77a16,16,0,0,0-15.18,10.94L40,158.7V64Z" fill="currentColor"/></svg>'

const defaultSummaryText = 'Case manager'


export default class CaseManager extends HTMLElement {
  constructor() {
    super()
    logger(this)

    this.loadedEvent = new CustomEvent('case-manager:loaded', {
      bubbles: true
    })
    this.deletedEvent = new CustomEvent('case-manager:deleted', {
      bubbles: true
    })

    this.details = this.querySelector('details')
    this.summary = this.querySelector('summary')
    this.innerEl = this.querySelector('#case-manager-inner')
    this.summary.addEventListener('click', (event) => {
      requestAnimationFrame(() => {
        if (this.details.open) {
          this.summary.innerHTML = openIcon + defaultSummaryText
          logger('heard details open', event)
        } else {
          // this.summary.innerHTML = closedIcon + `Case ID: <span class="case-id">${this.currentCase.caseId}</span>`
          this.summary.innerHTML = closedIcon + defaultSummaryText
          logger('heard details close', event)
        }
      })
    })
  }

  connectedCallback() {
    const exportBtn = this.querySelector('[data-case-manage="export"]')
    exportBtn.addEventListener('click', () => {
      this.exportCaseData()
    })

    this.deleteBtn = this.querySelector('[data-case-manage="delete"]')
    this.deleteConfirmBtn = this.querySelector('[data-case-manage="delete-confirm"]')
    this.deleteDialog = this.querySelector('dialog#case-delete')

    this.deleteBtn.addEventListener('click', () => {
      this.deleteDialog.showModal()
    })

    this.deleteConfirmBtn.addEventListener('click', () => {
      Storage.clear()
      this.deleteDialog.close()
      this.dispatchEvent(this.deletedEvent)
    })


    this.loadBtn = this.querySelector('[data-case-manage="load"]')
    this.loadDialog = this.querySelector('dialog#case-load')
    this.loadForm = this.querySelector('[data-case-form="load"]')
    this.loadInput = this.loadForm.querySelector('input[type="file"]')
    this.loadInfo = this.loadForm.querySelector('#load-case-data-preview')

    this.loadBtn.addEventListener('click', () => {
      this.loadDialog.showModal()
      // logger('heard change on file input', event, loadBtn.files)
    })

    this.loadInput.addEventListener('change', (event) => {
      logger('heard file input change', event.target.files[0])
      this.loadInfo.innerHTML = `<p>${event.target.files[0].name}</p>`
    })

    this.loadForm.addEventListener('submit', (event) => {
      event.preventDefault()
      logger('heard file input submit', event)

      const reader = new FileReader()
      reader.onload = (event) => {
        const loadedString = event.target.result
        const jsonResult = JSON.parse(loadedString)
        logger('loaded', jsonResult)

        const cleanedResult = Object.entries(jsonResult).map((entry) => {
          const key = entry[0].replace(/\"/g, "")
          const value = entry[1].replace(/\"/g, "")
          return [key, value === "true" ? true : value]
        })

        Storage.clear()

        cleanedResult.forEach((entry) => {
          logger('data entry:', entry)
          Storage.set(entry[0], entry[1])
        })

        this.loadForm.reset()
        this.loadDialog.close()
        this.dispatchEvent(this.loadedEvent)
      }

      reader.readAsText(this.loadInput.files[0])
    })
  }

  exportCaseData() {
    const caseData = JSON.stringify(localStorage, null, 4)
    const downloadLink = document.createElement('a')
    downloadLink.setAttribute('download', 'casedata.json')
    downloadLink.setAttribute('href', `data:text/json;charset=utf-8,${encodeURIComponent(caseData)}`)
    this.appendChild(downloadLink)
    downloadLink.click()
    this.removeChild(downloadLink)
  }

}

